import React, { useMemo, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';

import Button from '@material-ui/core/Button';
import { parseISO, format } from 'date-fns';
// import { ptBR } from 'date-fns/locale';
import { isNull } from 'lodash';

import QrFoto from '~/assets/icons/icons8-ms-excel.svg';
import QrIcon from '~/assets/icons/qrcode-icon.svg';
import { UnidataTable } from '~/components';
import { UnidataDialog } from '~/componentsLocal';
import CustomizedDialogs from '~/componentsLocal/UnidataDialog';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteCadastroDvec,
  findCadastroDvec,
  recordFiltering,
} from '~/store/modules/cadastrodvec/actions';

import Fotos from './components/Fotos';
import QRCodeDialog from './components/QRCodeDialog';
import Form from './form';

export default function CadastroDvec() {
  const redux = useSelector((state) => state.cadastrodvec);
  const [toggleQrCode, setToggleQrCode] = useState(false);
  const [cadastroDvec, setCadastroDvec] = useState('');

  const token = useSelector((state) => state.auth);

  const [tokenDescarga, setTokenDescarga] = useState(
    '175ac567-1766-4a15-9788-d28e6053904b'
  );

  const appUrl = `${
    window.location.host
  }/fotonf?id=${'175ac567-1766-4a15-9788-d28e6053904b'}&token=${JSON.stringify(
    token.token
  )}`;
  // const appUrl = `https://sua-aplicacao.com/pagina?id=${'175ac567-1766-4a15-9788-d28e6053904b'}`;

  const [toggleQrCodeNF, setToggleQrCodeNF] = useState(false);
  const [cadastroFotoNF, setCadastroFotoNF] = useState('');
  const [openedQrCodeNF, setOpenedQrCodeNF] = useState(false);

  const [opened, setOpened] = useState(false);

  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'descricaodispositivoinstalacaodvec',
        label: t('s.cadastro.motorista.nomemotorista'),
        filter: { type: 'text' },
      },
      {
        id: 'usocliente',
        label: t('s.configuracao.posto.nomeposto'),
      },
      {
        id: 'modelodispositivoinstalacaodvec',
        label: t('Modelo'),
      },
      {
        id: 'dataassociacaodispositivoinstalacaodvec',
        label: t('Data/hora Associação'),
        formatted: (value) =>
          isNull(value) ? '' : format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'statusdispositivoinstalacaodvec',
        label: t('s.cadastro.motorista.statusmotorista'),
        filter: { type: 'select', options: status },
        formatted: (value) => status.find((s) => s.label === value).value || '',
      },
    ],
    []
  );

  const actions = useMemo(
    () => [
      {
        title: t('Qr Code'),
        action: () => handleToggle(),
        icon: <img src={QrIcon} />,
      },
      // {
      //   title: t('Foto'),
      //   action: () => handleToggleOpen(),
      //   icon: <img src={QrFoto} />,
      // },
      // {
      //   title: t('Qr NF'),
      //   action: () => handleToggleQRcodeNFOpen(),
      //   icon: <img src={QrFoto} />,
      // },
    ],
    []
  );

  const handleToggle = () => {
    setToggleQrCode((value) => !value);
  };

  const handleToggleOpen = () => {
    setOpened((value) => !value);
  };

  const handleToggleQRcodeNFOpen = () => {
    setOpenedQrCodeNF((value) => !value);
  };

  const closeModal = () => {
    setOpened(false);
  };

  const fieldlist = [
    'descricaodispositivoinstalacaodvec',
    'usocliente',
    'modelodispositivoinstalacaodvec',
    'dataassociacaodispositivoinstalacaodvec',
    'statusdispositivoinstalacaodvec',
  ];

  const substituirHeader = {
    descricaodispositivoinstalacaodvec: t('s.cadastro.motorista.nomemotorista'),
    usocliente: t('s.configuracao.posto.nomeposto'),
    modelodispositivoinstalacaodvec: t('s.menu.cadastro.veiculo.modelo'),
    dataassociacaodispositivoinstalacaodvec: t('Data/hora Associação'),
    statusdispositivoinstalacaodvec: t('s.cadastro.motorista.statusmotorista'),
  };

  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={recordFiltering}
        find={findCadastroDvec}
        remove={deleteCadastroDvec}
        form={Form}
        keys="iddispositivoinstalacaodvec"
        detach="descricaodispositivoinstalacaodvec"
        actions={actions}
        onRow={(value) => {
          setCadastroDvec(value?.tokendispositivoinstalacaodvec);
        }}
        pdf
        excel
        onExport={(formato) =>
          handleExportGeneric({
            endpoint: 'dispositivosinstalacoesdvecs',
            formato,
            fields: fieldlist,
            headers: substituirHeader,
            redux,
            ordination: redux.params.ordination,
            orderfield: redux.params.orderfield,
            title: 'Relatório de Dispositivos PIN+',
            substituirValores: {
              statusdispositivoinstalacaodvec: {
                L: t('s.geral.opcoes.liberado'),
                B: t('s.geral.opcoes.bloqueado'),
                C: t('s.geral.opcoes.cancelado'),
              },
            },
          })
        }
      />

      <UnidataDialog
        open={toggleQrCode}
        handleClose={handleToggle}
        title="Qr Code"
        children={
          <QRCode
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={`${process.env.REACT_APP_URL_REQUEST}instalacoesdvecs/associadispositivo?token=${cadastroDvec}`}
            viewBox="0 0 256 256"
          />
        }
      />

      {/* <CustomizedDialogs
        open={opened}
        handleClose={closeModal}
        title={`Lançada nova versão ${process.env.REACT_APP_TAG}`}
        children={<Fotos />}
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.open('/changesrelease', '_blank');
                closeModal();
              }}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                closeModal();
              }}
            >
              Não
            </Button>
          </>
        }
      /> */}

      {/* <QRCodeDialog
        open={openedQrCodeNF}
        handleClose={handleToggleQRcodeNFOpen}
        title="Qr Code NF"
        children={
          <QRCode
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            // value={`${process.env.REACT_APP_URL_REQUEST}appqrcodefotosnf/geraurlappqrcodefotosnf?token=${tokenDescarga}`}
            value={`${appUrl}`}
            viewBox="0 0 256 256"
          />
        }
      /> */}
    </>
  );
}
